<template lang="pug">
el-container(style="height: 100vh" direction="vertical")
  publicHeader

  el-main
    .forgot
      router-link(:to="{name:'sign_in'}")
        i.el-icon-back {{ $t('sign_in.back_signin') }}
      el-form(label-position="top" label-width="100px" ref="form" :model="form")
        el-form-item(:label="$t('sign_in.email')" prop="email" clearable="")
          el-input(v-model="form.email")
      el-row(type="flex" justify="center")
        el-button(type="primary" @click="forgot") {{ $t('sign_in.forgot') }}

  publicFooter

</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'
import API from '@/api/user'

export default {
  data(){
    return {
      form: {
        email: ''
      }
    }
  },
  title() {
    return this.$t('sign_in.title01')
  },
  created() {
  },
  components: {
    'publicHeader': Header,
    'publicFooter': Footer
  },
  methods: {
    forgot: function(){
      if (this.validate()) {
        this.$message({ showClose: true, message: this.$t('sign_in.email_error'), type: 'error'})
        return
      }

      API.requestPasswordReset(this.form.email)
        .then(() => {
          this.$message({ showClose: true, message: this.$t('sign_in.password_reset_sent'), type: 'success'})
        }).catch((e) => {
          this.$message({ showClose: true, message: this.$t('sign_in.password_reset_error'), type: 'error'})
        })
    },
    // バリデーション
    validate: function(){
      var error = false
      var email = this.form.email

      if (email.length == 0){
        error = true
      }
      if (!this.validateEmail(email)){
        error = true
      }
      return error
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.el-icon-back {
  font-size: 12px;
  margin-bottom: 40px;
}

.el-input {
  margin-bottom: 20px;
}

.el-button {
  width: 100%;
  font-size: 16px;
  padding: 20px 0;
}

.el-form--label-top ::v-deep {
  .el-form-item__label {
    padding: 0;
    line-height: 30px;
    color: #999;
  }
}

.forgot {
  width: 320px;
  margin: 20px auto 0 auto;
  background: #FFF;
  padding: 40px;
  border-radius: 5px;
  border: 1px solid $border;
}

</style>
